import { cva } from '@/styled-system/css';

export const cardHeaderRecipe = cva({
  base: {
    'marginBlockEnd': 'Card.Header.margin.to-Body',

    '& > [data-c11n-component="Heading"]': {
      textStyle: 'heading-xs',
    },
  },
  variants: {
    divider: {
      true: {
        paddingBlockEnd: 'Card.Header.padding.from-Header',
        borderBlockEndWidth: '{borderWidths.Card.Header}',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'Card.Header.border',
      },
      false: {},
    },
  },
});
